import { render, staticRenderFns } from "./GroupsStats.vue?vue&type=template&id=3360555c&"
import script from "./GroupsStats.vue?vue&type=script&lang=js&"
export * from "./GroupsStats.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports